import {
  ContractInputInfoAll,
  ContractMethod,
  ErrorMessagesBaseForContractInputExcludePaymentTerm,
  getContractMethodsByTerm,
  PaymentInputDetail,
} from '../../../../Props/ContractInputInfo'
import {MBMemberError} from '../../../../Common/MBMemberError'
import React from 'react'
import {PaymentMethod} from '../../../../DTO/PaymentMethodDTO'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {PIMWarningMessages} from '../../../Atoms/Labels/PIMWarningMessages'
import {
  MBContentNoteWithMarkTypography,
  MBContentSubTitleTypography,
} from '../../../Atoms/Typographies'
import {PIMCard} from '../../../Atoms/Cards/PIMCard'
import {SignupDisplayPaymentMethodsRadioList} from './SignupDisplayPaymentMethodsRadioList'

export type SelectPaymentMethodContentsProps = {
  paymentMethodList: PaymentMethod[]
  contractInputInfoState: ContractInputInfoAll
  onChangeSelectedMethod: (changeSelectedMethod: ContractMethod) => void
  onChangeInputDetailInfo: (changeInputDetailInfo: PaymentInputDetail) => void
  errorMessages: ErrorMessagesBaseForContractInputExcludePaymentTerm
}

export const SignupSelectPaymentMethodContents: React.VFC<SelectPaymentMethodContentsProps> = (
  {
    paymentMethodList,
    contractInputInfoState,
    onChangeSelectedMethod,
    onChangeInputDetailInfo,
    errorMessages,
  }
) => {
  const contractMethods = getContractMethodsByTerm(paymentMethodList, contractInputInfoState.term)

  return (
    <PIMCard
      headerProps={{title: 'お支払い情報入力', require: true}}
      testId={'block-input-pay-information'}
    >
      <div>
        <MBContentSubTitleTypography>
          代金のお支払い方法を選択してください。
        </MBContentSubTitleTypography>
        <Spacer mt={'10px'}>
          <MBContentNoteWithMarkTypography note={
            contractMethods.find(paymentMethod => paymentMethod === 'convenience_store')
              ? 'コンビニ決済以外は自動課金継続となります。'
              : '自動課金継続となります。'
          }/>
        </Spacer>
        {errorMessages.paymentInputMethodErrors.length > 0 && (
          <Spacer mt={'12px'}>
            <PIMWarningMessages messages={errorMessages.paymentInputMethodErrors}/>
          </Spacer>
        )}
      </div>

      <Spacer mt={'18px'}>
        <PaymentMethodRadioList
          contractMethods={contractMethods}
          contractInputInfo={contractInputInfoState}
          errorMessages={errorMessages}
          onChangeSelectedMethod={(changeSelectedMethod: ContractMethod): void => {
            onChangeSelectedMethod(changeSelectedMethod)
          }}
          onChangeInputDetailInfo={(changeInputDetailInfo: PaymentInputDetail): void => {
            onChangeInputDetailInfo(changeInputDetailInfo)
          }}
        />
      </Spacer>
    </PIMCard>
  )
}

export type PaymentMethodRadioListProps = {
  contractMethods: ContractMethod[]
  contractInputInfo: ContractInputInfoAll
  errorMessages: ErrorMessagesBaseForContractInputExcludePaymentTerm
  onChangeSelectedMethod: (changeSelectedMethod: ContractMethod) => void
  onChangeInputDetailInfo: (changeInputDetailInfo: PaymentInputDetail) => void
}

const PaymentMethodRadioList: React.VFC<PaymentMethodRadioListProps> = (
  {
    contractMethods,
    contractInputInfo,
    errorMessages,
    onChangeSelectedMethod,
    onChangeInputDetailInfo,
  }
) => {
  if (Object.keys(contractMethods).length === 0) {
    throw new MBMemberError('SystemError')
  }

  return <SignupDisplayPaymentMethodsRadioList
    paymentMethodList={contractMethods}
    paymentInputDetailWithMethod={contractInputInfo}
    disabled={contractInputInfo.term === ''}
    errorMessages={errorMessages}
    onChangeSelectedMethod={(value: ContractMethod): void => onChangeSelectedMethod(value)}
    onChangeInputDetailInfo={(value: PaymentInputDetail): void => onChangeInputDetailInfo(value)}
  />
}
